const cleanTitleValue = (value) => {
  if (value === null || value === undefined) return "";

  const text = String(value).trim();
  if (!text || text === "-" || text.toLowerCase() === "null") return "";

  return text;
};

const firstCleanValue = (player, keys) => {
  for (const key of keys) {
    const value = cleanTitleValue(player?.[key]);
    if (value) return value;
  }

  return "";
};

export const buildPlayerWindowTitle = (player, fallbackTitle) => {
  if (!player?.last) return fallbackTitle;

  const name = `${cleanTitleValue(player.last)}, ${cleanTitleValue(player.first)}`.trim();
  const position = firstCleanValue(player, ["colPos1", "COL_POS1", "colPos"]);
  const schoolLong = firstCleanValue(player, ["longSchool", "LONGSCHOOL", "schoolLong", "SchoolLong"]);
  const cflDraftYear = firstCleanValue(player, ["cflDraftYear", "CFL_DRAFT_YEAR", "cflDy", "CFLDY"]);
  const nflDraftYear = firstCleanValue(player, ["nflDraftYear", "DRAFT_YEAR", "draftYear", "nflDy", "NFLDY"]);

  return [
    name,
    position,
    schoolLong,
    cflDraftYear ? `CFLDY: ${cflDraftYear}` : "",
    nflDraftYear ? `NFLDY: ${nflDraftYear}` : "",
  ]
    .filter(Boolean)
    .join(" - ");
};
